<template>
  <div id="app" class="home-page">
    <HeadNav
      selected-language="en"
      page="home"
      :gotodownload="gotodownload" />

    <main class="home-main">
      <section class="home-hero">
        <div class="hero-bg" aria-hidden="true">
          <span class="hero-bg-orb hero-bg-orb--one" />
          <span class="hero-bg-orb hero-bg-orb--two" />
          <span class="hero-bg-grid" />
        </div>
        <div class="hero-copy">
          <p class="security-marker">
            <i class="fa fa-shield-alt" aria-hidden="true" />
            Security Verified
          </p>
          <h1>GB WhatsApp APK Download Latest Version v18.80 for Android</h1>
          <p class="hero-text">
            Download GB WhatsApp APK Latest Version For Android 2026.
          </p>
          <a class="primary-download" :href="site.downloadPath">
            <i class="fa fa-cloud-download-alt" aria-hidden="true" />
            APK Download
          </a>
        </div>
        <div class="hero-visual" aria-hidden="true">
          <div class="hero-phone">
            <div class="hero-phone-screen">
              <img
                class="hero-phone-image"
                src="@/assets/save-video.webp"
                alt="">
            </div>
          </div>
        </div>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp APK Download Latest Version</h2>
        <p>
          Looking for the latest GB WhatsApp APK? Download the newest Android version and enjoy additional privacy controls, theme customization, larger media sharing, and other features that aren't available in the official WhatsApp app.
        </p>
        <p>
          This page includes the latest APK download, installation instructions, update information, version details, and answers to common questions, making it easy to get started in just a few minutes.
        </p>
      </section>

      <section class="content-section">
        <h2>APK Information</h2>
        <div class="table-wrap">
          <table class="info-table">
            <tbody>
              <tr v-for="row in apkInfo" :key="row.label">
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <a class="primary-download inline-download" :href="site.downloadPath">
          <i class="fa fa-cloud-download-alt" aria-hidden="true" />
          Download
        </a>
      </section>

      <section class="content-section">
        <h2>What Is GB WhatsApp?</h2>
        <p>
          <a href="/"><strong>GB WhatsApp</strong></a> is a modified version of WhatsApp designed for Android users who want more customization and privacy options. While the overall interface remains familiar, it adds features such as theme customization, status downloads, message scheduling, larger file sharing, and advanced privacy settings.
        </p>
        <p>
          Because it isn't available on Google Play, the app is installed manually using an APK file. Before updating or switching versions, it's a good idea to create a local backup of your chats.
        </p>
      </section>

      <section class="content-section feature-grid-section">
        <h2>Why Users Download GB WhatsApp</h2>
        <p class="section-lead">
          Most people download GB WhatsApp for features that go beyond the standard WhatsApp experience.
        </p>
        <div class="feature-grid">
          <article
            v-for="feature in features"
            :key="feature.title"
            class="feature-card"
            :class="{ 'feature-card--with-image': !!feature.image }">
            <div class="feature-card-icon" :class="`feature-card-icon--${feature.theme}`">
              <i class="fa" :class="feature.icon" aria-hidden="true" />
            </div>
            <div class="feature-card-body">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.text }}</p>
            </div>
            <img
              v-if="feature.image"
              class="feature-image"
              :src="feature.image"
              :alt="feature.title">
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>How to Download and Install GB WhatsApp</h2>
        <p>Installing <a href="/">GBWhatsApp</a> only takes a few steps:</p>
        <ol class="step-timeline">
          <li
            v-for="(step, index) in installSteps"
            :key="index"
            class="step-timeline-item">
            <div class="step-timeline-marker" aria-hidden="true">
{{ index + 1 }}
</div>
            <div class="step-timeline-body">
              <p
                class="step-timeline-text step-timeline-text--solo"
                v-html="step" />
            </div>
          </li>
        </ol>
        <p>Once the setup is complete, you can start using the latest version immediately.</p>
      </section>

      <section class="content-section">
        <h2>System Requirements</h2>
        <p>
          Before downloading the GBWhatsApp APK, make sure your Android device meets these minimum requirements.
        </p>
        <div class="table-wrap">
          <table class="info-table">
            <thead>
              <tr>
                <th>Requirement</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in systemRequirements" :key="row.label">
                <th>{{ row.label }}</th>
                <td v-html="row.value" />
              </tr>
            </tbody>
          </table>
        </div>
        <p class="muted">
          Most modern Android phones can run the latest version without additional configuration.
        </p>
      </section>

      <section class="content-section">
        <h2>Device Compatibility</h2>
        <p>
          GB WhatsApp is designed for Android smartphones and tablets. Compatibility may vary depending on your Android version, device manufacturer, and the specific APK release. Older devices may need to use a previous version for the best experience.
        </p>
      </section>

      <section id="comparison" class="content-section">
        <h2>GB WhatsApp vs Official WhatsApp</h2>
        <p>
          GB WhatsApp app and Official WhatsApp provide a similar messaging experience, but they are designed for different types of users. The official app focuses on stability, security, and official support, while GB WhatsApp offers additional customization and privacy options through a modified experience.
        </p>
        <p>Here is a detailed comparison of both apps:</p>
        <div class="table-wrap">
          <table class="comparison-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Official WhatsApp</th>
                <th>GB WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in comparisonRows" :key="row.label">
                <th>{{ row.label }}</th>
                <td>{{ row.official }}</td>
                <td>{{ row.gb }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="choice-grid">
          <div>
            <h3>Choose Official WhatsApp if you want:</h3>
            <ul class="guide-dot-list">
              <li v-for="item in officialChoice" :key="item">
{{ item }}
</li>
            </ul>
          </div>
          <div>
            <h3>Choose <a href="/">GB WhatsApp</a> if you want:</h3>
            <ul class="guide-dot-list">
              <li v-for="item in gbChoice" :key="item">
{{ item }}
</li>
            </ul>
          </div>
        </div>
      </section>

      <section class="content-section">
        <h2>What's New in GB WhatsApp v18.80</h2>
        <ul class="guide-dot-list">
          <li v-for="item in whatsNew" :key="item">
{{ item }}
</li>
        </ul>
      </section>

      <section class="content-section">
        <h2>Is GB WhatsApp Safe?</h2>
        <p>
          GB WhatsApp is a third-party modified application and is not distributed through Google Play. Before installing it, users should understand that modified apps may involve different security and compatibility considerations than official applications.
        </p>
        <p>
          To reduce potential issues, always keep a backup of your chats, install the latest available version, and download APK files only from a source you trust.
        </p>
      </section>

      <section class="content-section">
        <h2>Why Choose GB WhatsApp?</h2>
        <p>
          Many Android users choose GB WhatsApp Pro because it offers more flexibility than the standard WhatsApp experience. Instead of changing the way you chat, it focuses on giving users greater control over privacy, customization, and media sharing while keeping the familiar interface that most people already know.
        </p>
        <p>
          Compared with the official app, it includes more personalization options, additional chat tools, and features that appeal to users who want a more customizable messaging experience.
        </p>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp Latest Version Updates</h2>
        <p>
          We regularly update this page whenever a new GBWhatsApp APK becomes available. Each release may include bug fixes, compatibility improvements, performance optimizations, and support for newer Android versions.
        </p>
        <p>
          If you're already using an older release, updating to the latest version can help improve stability and ensure you have access to the newest features.
        </p>
      </section>

      <section class="content-section">
        <h2>GBWhatsApp Version History</h2>
        <p>
          We update this page whenever a new version becomes available. If you prefer an earlier release or need a compatible version for your device, you can also browse our <strong>Old Versions</strong> archive.
        </p>
        <div class="table-wrap">
          <table class="info-table">
            <thead>
              <tr>
                <th>Version</th>
                <th>Release</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in versionHistory" :key="row.version">
                <td>{{ row.version }}</td>
                <td>{{ row.release }}</td>
                <td>{{ row.notes }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <strong>Need an older release?</strong> Visit this
          <a href="https://gbwtsp.com/gbwhatsapp-old-versions/" rel="noopener">GB WhatsApp Old Versions</a>
          page to download previous APKs.
        </p>
      </section>

      <section class="content-section">
        <h2>Who Is GB WhatsApp For?</h2>
        <p>
          GB WhatsApp is designed for Android users who want more control over their messaging experience. It's a popular choice for people who prefer additional privacy settings, interface customization, larger media sharing, or the ability to use two WhatsApp accounts on the same device.
        </p>
        <p>
          If you prefer automatic updates through Google Play and only need the standard messaging features, the official WhatsApp app may be a better choice.
        </p>
      </section>

      <section class="content-section">
        <h2>FAQ</h2>
        <article v-for="faq in faqs" :key="faq.question" class="faq-item">
          <h3>{{ faq.question }}</h3>
          <p>{{ faq.answer }}</p>
        </article>
      </section>

      <section class="content-section">
        <h2>Why Trust This Page?</h2>
        <p>
          We keep this page updated with the latest available version, installation instructions, and update notes, so you can quickly find the information you need before downloading.
        </p>
      </section>

      <section class="content-section ready-section">
        <h2>Ready to Download?</h2>
        <p>
          Download the latest GB WhatsApp APK and follow the installation guide to start using the newest version on your Android device.
        </p>
        <a class="primary-download" :href="site.downloadPath">
          <i class="fa fa-cloud-download-alt" aria-hidden="true" />
          Download Button
        </a>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import site from '@/config/site.json';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      site,
      apkInfo: [
        { label: 'Latest Version', value: 'v18.80' },
        { label: 'File Size', value: '90 MB' },
        { label: 'Android Requirement', value: 'Android 5.0+' },
        { label: 'File Format', value: 'APK' },
        { label: 'Last Updated', value: 'August 2026' },
        { label: 'Price', value: 'Free' },
      ],
      features: [
        {
          title: 'Advanced Privacy Controls',
          text: 'Choose who can see your online status, last seen, typing indicator, and other activity. Depending on the version, you can customize these settings to match your privacy preferences.',
          icon: 'fa-lock',
          theme: 'green',
        },
        {
          title: 'Download Status',
          text: 'Save photos and videos shared in Status directly to your device without using a separate downloader.',
          icon: 'fa-download',
          theme: 'blue',
        },
        {
          title: 'Larger File Sharing',
          text: 'Send larger videos, documents, audio files, and more photos in a single message compared with the standard app.',
          icon: 'fa-file-image',
          theme: 'teal',
        },
        {
          title: 'Dual Accounts',
          text: 'Use a second WhatsApp account on the same Android device, making it easier to separate personal and work conversations.',
          icon: 'fa-clone',
          theme: 'purple',
        },
        {
          title: 'Built-in App Lock',
          text: 'Protect your chats with a PIN, password, or fingerprint on supported devices without installing another locking app.',
          icon: 'fa-fingerprint',
          theme: 'green',
        },
        {
          title: 'Multiple Languages',
          text: 'Choose from a variety of supported languages to use the app more comfortably in your preferred language.',
          icon: 'fa-user-circle',
          theme: 'blue',
        },
        {
          title: 'Custom Themes',
          text: 'Change colors, fonts, icons, wallpapers, and other interface elements to personalize the app.',
          image: require('@/assets/themes-4k.webp'),
          icon: 'fa-palette',
          theme: 'orange',
        },
        {
          title: 'Auto Reply & Message Scheduler',
          text: 'Automatically reply to incoming messages or schedule messages to be sent at a later time.',
          image: require('@/assets/Auto-Reply.webp'),
          icon: 'fa-reply',
          theme: 'indigo',
        },
      ],
      installSteps: [
        'Download the latest APK using the button above.',
        'Enable <strong>Install Unknown Apps</strong> in your Android settings if prompted.',
        'Open the APK file and complete the installation.',
        'Verify your phone number and restore your local backup if you have one.',
      ],
      systemRequirements: [
        { label: 'Operating System', value: 'Android 5.0 or later' },
        { label: 'Storage Space', value: 'At least 500 MB available' },
        { label: 'RAM', value: '2 GB or more recommended' },
        { label: 'Internet Connection', value: 'Required for download and verification' },
        { label: 'Installation', value: 'Enable <strong>Install Unknown Apps</strong> when prompted' },
      ],
      comparisonRows: [
        { label: 'Developer', official: 'Developed and maintained by Meta', gb: 'Developed by independent third-party developers' },
        { label: 'Availability', official: 'Available on Google Play Store and App Store', gb: 'Available as an APK download from third-party sources' },
        { label: 'Supported Devices', official: 'Android, iPhone (iOS), Web, Windows, Mac', gb: 'Mainly Android devices' },
        { label: 'Installation Method', official: 'Install directly from official app stores', gb: 'Manual APK installation required' },
        { label: 'Account Support', official: 'Supports standard WhatsApp accounts', gb: 'Supports WhatsApp accounts with additional options depending on the version' },
        { label: 'Interface', official: 'Fixed official design', gb: 'Similar interface with extra customization options' },
        { label: 'Themes & Customization', official: 'Limited customization', gb: 'More themes, fonts, wallpapers, and UI options' },
        { label: 'Privacy Controls', official: 'Standard privacy settings', gb: 'Additional privacy options may be available depending on the version' },
        { label: 'Status Download', official: 'Not available by default', gb: 'Built-in status download feature in many versions' },
        { label: 'Media Sharing', official: 'Standard WhatsApp limits', gb: 'Higher sharing limits in some versions' },
        { label: 'Auto Reply', official: 'Available mainly through WhatsApp Business', gb: 'Available in many GB WhatsApp versions' },
        { label: 'Message Scheduling', official: 'Not available in standard WhatsApp', gb: 'Available in supported versions' },
        { label: 'Dual Accounts', official: 'Depends on device features', gb: 'Designed with multiple account support in mind' },
        { label: 'Updates', official: 'Regular updates from Meta', gb: 'Updates depend on third-party developers' },
        { label: 'Security Updates', official: 'Receives official security patches', gb: 'May not receive official WhatsApp security updates' },
        { label: 'Customer Support', official: 'Official WhatsApp Help Center', gb: 'Usually relies on community support or the download provider' },
        { label: 'Data Backup', official: 'Supports Google Drive/iCloud backups', gb: 'Usually relies on local backups and available migration methods' },
      ],
      officialChoice: [
        'Official support from Meta',
        'Automatic updates through app stores',
        'The highest level of compatibility',
        'Standard messaging features without modifications',
      ],
      gbChoice: [
        'More interface customization',
        'Additional privacy controls',
        'Extra messaging tools',
        'More flexibility with themes and media options',
      ],
      whatsNew: [
        'Improved compatibility with the latest Android versions',
        'Fixed several known bugs and crashes',
        'Better media sharing performance',
        'Updated privacy options',
      ],
      versionHistory: [
        { version: 'v18.70', release: '2025', notes: 'Better anti ban' },
        { version: 'v18.30', release: '2025', notes: 'Bug fixes' },
        { version: 'v17.60', release: '2024', notes: 'Smooth performance' },
        { version: 'v17.00', release: '2024', notes: 'Improved privacy controls' },
      ],
      faqs: [
        {
          question: 'Is this the latest GB WhatsApp APK?',
          answer: 'Yes. This page is updated whenever a newer version becomes available.',
        },
        {
          question: 'Can I update without losing my chats?',
          answer: 'In most cases, yes. Create a local backup before updating and restore it during setup.',
        },
        {
          question: 'Does GB WhatsApp work on all Android phones?',
          answer: 'It supports most Android devices running Android 5.0 or later, although compatibility may vary by device and version.',
        },
        {
          question: 'Can I use GB WhatsApp together with the official WhatsApp?',
          answer: 'Yes. Many users run both apps on the same device by registering different phone numbers.',
        },
        {
          question: 'How do I update to the newest version?',
          answer: 'Simply download the latest APK from this page and install it over your existing version if the package is compatible. Backing up your chats beforehand is recommended.',
        },
      ],
    };
  },
  methods: {
    gotodownload() {
      if (typeof window !== 'undefined') {
        window.location.href = this.site.apkUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
  background: #f6f8fb;
}

.home-main {
  width: min(960px, calc(100% - 30px));
  margin: 0 auto;
  padding: 20px 0 60px;
}

.home-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "copy visual";
  gap: 16px 18px;
  align-items: center;
  padding: 16px 40px 16px 40px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  background: linear-gradient(145deg, #023d22 0%, #046338 42%, #067a44 78%, #08964f 100%);
  color: #fff;
  box-shadow:
    0 18px 40px rgba(2, 61, 34, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.16);
  isolation: isolate;
}

.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.hero-bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
}

.hero-bg-orb--one {
  top: -70px;
  right: -50px;
  width: 240px;
  height: 240px;
  background: rgba(37, 211, 102, 0.32);
}

.hero-bg-orb--two {
  bottom: -80px;
  left: 18%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.08);
}

.hero-bg-grid {
  position: absolute;
  inset: 0;
  opacity: 0.28;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 50%, #000 20%, transparent 100%);
}

.hero-copy,
.hero-visual {
  position: relative;
  z-index: 1;
}

.hero-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
  grid-area: copy;
}

.hero-visual {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-area: visual;
}

.security-marker {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 5px 11px 5px 9px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.03em;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
}

.security-marker .fa {
  font-size: 12px;
  color: #7dffb0;
}

.hero-copy h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(24px, 3.2vw, 34px);
  line-height: 1.18;
  letter-spacing: -0.02em;
  text-wrap: balance;
  text-shadow: 0 2px 18px rgba(0, 0, 0, 0.16);
}

.hero-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 15px;
  line-height: 1.5;
}

.hero-copy .primary-download {
  margin-top: 8px;
}

.primary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 168px;
  min-height: 44px;
  padding: 10px 20px;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 10px;
  background: linear-gradient(180deg, #fff 0%, #f0faf4 100%);
  color: #0b6d47;
  font-size: 15px;
  font-weight: 800;
  text-decoration: none;
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.16),
    0 1px 0 rgba(255, 255, 255, 0.6) inset;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.primary-download:hover {
  transform: translateY(-2px);
  background: #fff;
  box-shadow:
    0 16px 36px rgba(0, 0, 0, 0.22),
    0 2px 0 rgba(255, 255, 255, 0.7) inset;
}

.primary-download:active {
  transform: translateY(0);
}

.primary-download .fa {
  font-size: 1.05em;
}

.inline-download {
  margin-top: 18px;
}

.content-section .primary-download {
  border: none;
  min-width: 180px;
  min-height: 48px;
  padding: 12px 22px;
  background: #0b6d47;
  color: #fff !important;
  font-size: 16px;
  box-shadow: 0 8px 24px rgba(11, 109, 71, 0.22);
}

.content-section .primary-download:hover {
  background: #0a5f3e;
  color: #fff !important;
}

.hero-phone {
  position: relative;
  display: inline-block;
  padding: 8px 7px 10px;
  border-radius: 26px;
  background: linear-gradient(165deg, #2f2f2f 0%, #141414 48%, #232323 100%);
  box-shadow:
    0 16px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    inset 0 -1px 0 rgba(0, 0, 0, 0.45);
}

.hero-phone::before {
  position: absolute;
  top: 56px;
  right: -2px;
  width: 3px;
  height: 28px;
  border-radius: 0 2px 2px 0;
  background: linear-gradient(180deg, #3a3a3a, #1a1a1a);
  content: '';
  opacity: 0.85;
}

.hero-phone-screen {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  background: #050505;
  line-height: 0;
}

.hero-phone-screen::before {
  position: absolute;
  z-index: 2;
  top: 10px;
  left: 50%;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #3a3a3a, #0a0a0a 65%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.06);
  content: '';
  transform: translateX(-50%);
}

.hero-phone-screen::after {
  position: absolute;
  z-index: 2;
  bottom: 8px;
  left: 50%;
  width: 88px;
  height: 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  content: '';
  transform: translateX(-50%);
}

.hero-phone-image {
  display: block;
  width: min(196px, calc(24vw - 12px));
  height: auto;
  object-fit: contain;
  filter: saturate(1.04) contrast(1.02) brightness(0.98);
}

.content-section {
  margin-top: 22px;
  padding: 30px 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.06);
}

.content-section h2 {
  margin: 0 0 18px;
  color: #14213d;
  font-size: 28px;
  line-height: 1.25;
  letter-spacing: 0;
}

.content-section h3 {
  margin: 22px 0 8px;
  color: #14213d;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: 0;
}

.content-section p,
.section-lead {
  margin: 0 0 14px;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.78;
}

.content-section p strong {
  color: #14213d;
  font-weight: 700;
}

.content-section a {
  color: #2563eb !important;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.content-section a strong {
  color: inherit;
  font-weight: 700;
}

.content-section a:hover,
.content-section a:focus {
  color: #1d4ed8 !important;
}

.content-section .primary-download {
  text-decoration: none;
}

.muted {
  margin-top: 18px;
  color: #64748b;
  font-size: 14px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px 28px;
}

.feature-card {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 14px;
  padding: 0;
  border: none;
  background: transparent;
}

.feature-card-icon {
  display: flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
}

.feature-card-icon--green {
  background: #e8f7ef;
  color: #0b6d47;
}

.feature-card-icon--blue {
  background: #e8f2fc;
  color: #2563eb;
}

.feature-card-icon--orange {
  background: #fff3e8;
  color: #ea580c;
}

.feature-card-icon--teal {
  background: #e6f7f5;
  color: #0d9488;
}

.feature-card-icon--purple {
  background: #f3ecfb;
  color: #9333ea;
}

.feature-card-icon--indigo {
  background: #eef0ff;
  color: #4f46e5;
}

.feature-card-body {
  min-width: 0;
  flex: 1;
}

.feature-card-body h3 {
  margin: 2px 0 5px;
  color: #14213d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.feature-card-body p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.55;
}

.feature-card--with-image {
  flex-wrap: nowrap;
  align-items: flex-start;
}

.feature-card--with-image .feature-card-body {
  flex: 1 1 0;
}

.feature-image {
  display: block;
  flex: 0 0 100%;
  width: auto;
  max-width: 168px;
  max-height: 220px;
  height: auto;
  margin: 4px auto 0;
  border-radius: 6px;
  background: #f1f5f9;
  object-fit: contain;
}

.feature-card--with-image .feature-image {
  flex: 0 0 auto;
  width: 200px;
  max-width: 46%;
  max-height: 280px;
  margin: 0;
}

.table-wrap {
  overflow-x: auto;
  margin-bottom: 24px;
}

.info-table,
.comparison-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.info-table th,
.info-table td,
.comparison-table th,
.comparison-table td {
  padding: 12px 14px;
  border: 1px solid #dde4ec;
  text-align: left;
  vertical-align: top;
}

.info-table th,
.comparison-table th {
  width: 30%;
  background: #f1f5f9;
  color: #14213d;
  font-weight: 700;
}

.info-table td strong {
  color: #14213d;
  font-weight: 700;
}

.step-timeline {
  list-style: none;
  margin: 20px 0 0;
  padding: 0;
}

.step-timeline-item {
  position: relative;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
  padding-bottom: 24px;
}

.step-timeline-item:last-child {
  padding-bottom: 0;
}

.step-timeline-item:not(:last-child)::after {
  position: absolute;
  top: 40px;
  bottom: 0;
  left: 20px;
  width: 2px;
  background: linear-gradient(180deg, #b8e6cf 0%, #e5f5ec 100%);
  content: '';
  transform: translateX(-50%);
}

.step-timeline-marker {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  justify-self: center;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border: 2px solid #9dd4b8;
  border-radius: 50%;
  background: #f4fbf7;
  color: #0b6d47;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.step-timeline-body {
  padding-top: 8px;
}

.step-timeline-text--solo {
  margin: 0;
  padding-top: 2px;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.7;
}

.step-timeline-text strong {
  color: #14213d;
  font-weight: 700;
}

.guide-dot-list {
  list-style: none !important;
  margin: 12px 0 0 !important;
  padding: 0 !important;
}

.guide-dot-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-left: 0;
  list-style: none !important;
  color: #3c4b62;
  line-height: 1.7;
}

.guide-dot-list li::before {
  flex: 0 0 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  content: '';
}

.guide-dot-list li::marker {
  content: '';
}

.guide-dot-list li:last-child {
  margin-bottom: 0;
}

.choice-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  margin-top: 26px;
}

.faq-item {
  padding: 18px 0;
  border-top: 1px solid #e5e7eb;
}

.faq-item:first-child {
  border-top: 0;
}

.faq-item h3 {
  margin-top: 0;
}

.faq-item p {
  margin-bottom: 0;
}

.ready-section {
  text-align: center;
}

.ready-section .primary-download {
  margin-top: 10px;
}

@media (max-width: 900px) {
  .home-hero {
    grid-template-columns: 1fr;
    grid-template-areas:
      "visual"
      "copy";
    padding: 16px 18px;
  }

  .hero-visual {
    justify-content: center;
  }

  .hero-phone-image {
    width: min(176px, calc(52vw - 16px));
  }

  .feature-grid,
  .choice-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .home-main {
    width: min(100% - 20px, 960px);
    padding-top: 10px;
  }

  .home-hero {
    padding: 16px 18px;
    border-radius: 16px;
  }

  .content-section {
    padding: 28px 20px;
  }

  .feature-card--with-image {
    flex-wrap: wrap;
  }

  .feature-card--with-image .feature-image {
    flex-basis: 100%;
    width: auto;
    max-width: 200px;
    margin: 8px auto 0;
  }

  .hero-copy h1 {
    font-size: 24px;
    letter-spacing: -0.01em;
  }

  .primary-download {
    width: 100%;
  }
}
</style>
